import { Controller } from "@hotwired/stimulus"
import { submitForm } from "helpers/form_helpers"

const AUTOSAVE_INTERVAL = 1500

export default class extends Controller {
  static targets = ["status"]

  #timer

  disconnect() {
    this.#resetTimer()
  }

  change() {
    this.#resetTimer()
    this.#updateStatus("Unsaved changes")
    this.#scheduleSave()
  }

  async submit() {
    if (this.#timer) await this.#save()
  }

  #scheduleSave() {
    this.#timer = setTimeout(() => this.#save(), AUTOSAVE_INTERVAL)
  }

  async #save() {
    this.#resetTimer()
    try {
      const { ok } = await submitForm(this.element, { "X-Autosave": "true" })
      this.#updateStatus(ok ? "Saved" : "Error saving")
      if (ok) setTimeout(() => this.#updateStatus(""), 2000)
    } catch {
      this.#updateStatus("Error saving")
    }
  }

  #resetTimer() {
    clearTimeout(this.#timer)
    this.#timer = null
  }

  #updateStatus(text) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
  }

}
